import React, { Fragment } from 'react'
import './Checkbox.styl'

const Checkbox = props => (
  <Fragment>
    <input name={props.name} type="checkbox" className="c-checkbox__input" onChange={props.onChange}/>
    <div className="c-checkbox__div" />
  </Fragment>
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js